import { IsUUID, ValidateIf, IsString, IsOptional } from 'class-validator';
import { ApiPropertyOptional } from '@nestjs/swagger';

export class SetStateDto {
  @ApiPropertyOptional({
    description: "ID d'état cible (exclu si stateCode fourni)",
    format: 'uuid',
    type: 'string',
  })
  @ValidateIf((o) => !o.stateCode && !o.newStateId)
  @IsUUID('4')
  stateId?: string;

  @ApiPropertyOptional({
    description: "Code d'état cible (exclu si stateId fourni)",
    example: 'PUBLISHED',
    type: 'string',
  })
  @ValidateIf((o) => !o.stateId && !o.newStateId)
  @IsString()
  stateCode?: string;

  // Compat: alias legacy (sera copié côté service si présent)
  @ApiPropertyOptional({
    description: 'Alias legacy pour stateId',
    deprecated: true,
    type: 'string',
  })
  @IsOptional()
  @IsUUID('4')
  newStateId?: string;
}
